// extracted by mini-css-extract-plugin
module.exports = {"container":"_80b09__common-module__container"};